export class ListDataCatalogNamespacesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespaces",
            "baseName": "namespaces",
            "type": "Array<DataCatalogNamespace>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogNamespacesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
